import * as selector from './selectors';

export const offerSelector = selector;
export * from './actions';
export { default as reducer } from './reducer';
